module.exports = __webpack_public_path__ + "img/0Q3A2198_L_Foamcore_MockedUp.d788b61a.jpg";